// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1aF1c","infoBtn":"quickbooks_infoBtn__3HR7d","formBox":"quickbooks_formBox__3VAPq","formFooter":"quickbooks_formFooter__1h9ND"};